import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import Button from '../../../../../common/components/Button';
import Options from '../../../../../common/components/Options';
import {CALCULATOR, CALCULATOR_MX, ERROR, GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {formatCurrency} from '../../../../utils/CurrencyUtils';
import {CalculatorStepProps, CalculatorStepState} from '../../../../types/mx/creditoReal/components';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import LandingCheck from '../../../../../common/components/LandingCheck';
import LandingFeature from '../../../../../common/components/LandingFeature';
import OptionsMonthly from '../../../../../common/components/OptionsMonthly';
import {Catalog} from '../../../../../common/types/common';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import InputRange from '../../../../../common/components/InputRange';
import {splitDecimal} from '../../../../../common/utils/NumberUtils';
import Link from '../../../../../common/components/Link';
import {COUNTRY_INITIALS} from '../../../../../common/constants/AppConstants';
import SimulatorAccordion from '../../../../../common/components/accordions/SimulatorAccordion';
import InputText from '../../../../../common/components/InputText';
import {INPUTS} from '../../../../../admin/constants/MX/AdminInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';

class SimulatorStepView extends React.Component<CalculatorStepProps, CalculatorStepState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onPressNext = () => {
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    onChangePostalCode = (postalCode, error) => {
        this.setState(
            {showErrors: true},
            this.props.onChangePostalCode(postalCode, error)
        );
    }

    checkIfPressNext = () => {
        if (this.props.hasCalculatorFieldsError) {
            return this.props.onPressNext();
        }
    }

    onPressUpdate = () => {
        this.setState({showErrors: true}, this.checkIfPressUpdate);
    }

    checkIfPressUpdate = () => {
        if (this.props.hasCalculatorFieldsError) {
            return this.props.onPressUpdate();
        }
    }

    renderQuotas = () => {
        const {defaultMonthlyPayment, monthlyPayments, monthlyPaymentField} = this.props;
        const defaultMonthlyPaymentItem = defaultMonthlyPayment[defaultMonthlyPayment.length - 1];
        const monthlyQuotaValue = !!monthlyPayments ? monthlyPayments.find(monthlyPayment =>
            monthlyPayment.value === monthlyPaymentField.value.value
        ) : '';
        return <React.Fragment>
            <div className="row monthly-quotes">
                <div className="col">
                    <div className="row">
                        <div className="col title-quotes">{CALCULATOR_MX.MONTHLY_PAYMENTS_SIMULATOR}</div>
                    </div>
                    {!monthlyQuotaValue && <div className="row">
                        <div className="col sub-title-quotes d-flex align-items-center justify-content-center">
                            {CALCULATOR_MX.MONTHLY_PAYMENTS_DETAIL_SIMULATOR}
                        </div>
                    </div>}
                    {monthlyQuotaValue && <div>
                        <div className="row">
                            <div className="col value-quotes d-flex align-items-center justify-content-center">
                                {!!monthlyQuotaValue.label && splitDecimal(monthlyQuotaValue.label[1]).integerPart}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col value-quotes value-quotes-small d-flex align-items-center justify-content-center">
                                {`Hasta: ${!!monthlyQuotaValue.labelSh3 && splitDecimal(monthlyQuotaValue.labelSh3[1]).integerPart}`}
                            </div>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col">
                            <OptionsMonthly id={'quotas'}
                                            name={'quotas'}
                                            options={this.props.monthlyPayments || this.props.defaultMonthlyPayment}
                                            required={true}
                                            hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                            labelError={this.props.monthlyPaymentField.error}
                                            onChange={this.props.onChangeMonthlyPayment}
                                            defaultValue={this.props.monthlyPaymentField.value.value ||
                                            defaultMonthlyPaymentItem.value}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row financing-details">
                <div className="col">
                    {
                        this.props.isInsuranceInFinancing ?
                            <div className="row section-details border-bottom mt-3 pb-3">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">{CALCULATOR_MX.ANNUAL_INSURANCE}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col description mb-2">
                                            {this.props.isInsuranceInFinancing ?
                                                CALCULATOR_MX.ANNUAL_INSURANCE_INCLUDED_MONTHLY_PAYMENT :
                                                ''}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">{this.props.insuranceAmount || '$ — —'}</div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                    <div className="row section-details mt-2 pb-2">
                        <div className="col">
                            <div className="row">
                                <div className="col title">{CALCULATOR_MX.FINANCING_AMOUNT}</div>
                            </div>
                            <div className="row">
                                <div className="col description mb-2">
                                    {`${CALCULATOR_MX.FINANCING_AMOUNT_DETAIL} ${this.props.isInsuranceInFinancing ?
                                        CALCULATOR_MX.FINANCING_AMOUNT_DETAIL_INSURANCE_ANUAL :
                                        ''}`}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col value">{this.props.financingAmount || '$ — —'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col title-header">{CALCULATOR_MX.CASH_PAYMENTS}:</div>
                    </div>
                    {
                        this.props.isInsuranceInFinancing ? null :
                            <div className="row section-details mt-2 pb-2">
                                <div className="col">
                                    <div className="row">
                                        <div className="col title">{CALCULATOR_MX.ANNUAL_INSURANCE}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col value">{this.props.insuranceAmount || '$ — —'}</div>
                                    </div>
                                </div>
                            </div>
                    }
                    <div className="row section-details mt-2 pb-2">
                        <div className="col">
                            <div className="row">
                                <div className="col title">{CALCULATOR_MX.COMMISSION_AMOUNT}</div>
                            </div>
                            <div className="row">
                                <div className="col description">
                                    {CALCULATOR_MX.COMMISSION_AMOUNT_DETAIL_SIMULATOR}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col value">{this.props.commissionAmount || '$ — —'}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }

    renderNextUpdateButton() {
        if (this.props.loanApplicationToken) {
            return <Button text={CALCULATOR.UPDATE} onPress={this.onPressUpdate} customClass="btn-block px-md-3"/>;
        }
        return <Button text={CALCULATOR.START_LOAN} onPress={this.onPressNext} customClass="btn-block px-md-3"/>;
    }

    onChangeYear = (year: number, error: string, maxYear: number) => {
        const {onChangeYear, years} = this.props;
        const yearLength: number = year.toString().length;
        const strMaxYear: string = maxYear.toString();
        const strYear: string = year.toString();
        const maxYearCatalog = !!!year ? {id: strMaxYear, value: strMaxYear, payload: ''} : {
            id: strYear,
            value: strYear,
            payload: ''
        };
        if (yearLength === 4) {
            const yearFound: Catalog = years.find(y => y.value === strYear);
            const yearSelected = !!yearFound ? yearFound : maxYearCatalog;
            const newError: string = !!yearFound ? error : ValidateConstant.YEAR_OUT_OF_RANGE;

            onChangeYear(yearSelected, newError);
        } else {
            onChangeYear(maxYearCatalog, !!year ? error : null);
        }
    }

    render() {
        const {
            landing, priceField, minPrice, downPaymentField,
            minDownPaymentValue, years, yearSelectedField, maxDownPayment,
            disabledEditVehicle
        } = this.props;
        const priceSelected: string = priceField.value;
        const downPaymentSelected: string = downPaymentField.value;
        const yearValues: number[] = years.length > 0 ? years.map(y => parseInt(y.value, 10)) : [0];
        const minYear: number = Math.min(...yearValues);
        const maxYear: number = Math.max(...yearValues);
        const selectedYear: string = yearSelectedField.value.value;
        const maxRange: number = Math.trunc(parseFloat(priceSelected) * maxDownPayment) || 0;
        const urlToSeminuevos = 'https://www.seminuevos.com/usados/-/autos?type_autos_motor-credit-status=activado';
        return (
            <React.Fragment>
                <div className={`container px-0 ${landing ? 'wizard-landing' : ''}`}>
                    <h3 className="text-raleway text-secondary-lighten-1">Lo hacemos todo por ti.</h3>
                    <span className="regular-text sub-title">Financiamos y encontramos el auto de tus sueños</span>
                    <span className="regular-text sub-sub-title">Simula tu crédito</span>
                    <div className="row m-0 p-0">
                        <div className="col side-form">
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'precio'}
                                                min={minPrice} max={9999999}
                                                label={CALCULATOR.PRICE}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minPrice, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                                labelError={this.props.priceField.error}
                                                defaultValue={priceSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangePrice}
                                                disabled={disabledEditVehicle}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'enganche'}
                                                min={parseInt(minDownPaymentValue, 10)}
                                                max={maxRange}
                                                label={CALCULATOR.ENTRY_MX}
                                                required={true}
                                                maxLength={7}
                                                step={100}
                                                helpText={`Mínimo ${formatCurrency(
                                                    minDownPaymentValue, COUNTRY_INITIALS.MEXICO, '$', 0)}`}
                                                hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                                labelError={this.props.downPaymentField.error}
                                                defaultValue={downPaymentSelected}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                isCurrency={true}
                                                currencyFormat={COUNTRY_INITIALS.MEXICO}
                                                onChangeBox={this.props.onChangeDownPayment}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputRange position="right" id={'year'}
                                                min={minYear}
                                                max={maxYear}
                                                maxLength={4}
                                                label={CALCULATOR.VEHICLE_YEAR}
                                                required={true}
                                                step={1}
                                                helpText={!!yearSelectedField.error ?
                                                    `Mínimo ${minYear}, Máximo ${maxYear}` : ''}
                                                showValueOnMouseUp={false}
                                                hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                                labelError={this.props.yearSelectedField.error}
                                                defaultValue={selectedYear}
                                                colorSelected="#7859AB" colorBackGround="#b3b3b3"
                                                disabled={disabledEditVehicle}
                                                onChangeBox={(value, error) =>
                                                    this.onChangeYear(value, error, maxYear)}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'brand'}
                                        label={CALCULATOR.BRAND}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.brandSelectedField.value}
                                        data={this.props.brands}
                                        required={true}
                                        onChange={this.props.onChangeBrand}
                                        labelError={this.props.brandSelectedField.error}
                                        hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                        disabled={disabledEditVehicle}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'model'}
                                        label={CALCULATOR.MODEL}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.modelSelectedField.value}
                                        data={this.props.models}
                                        required={true}
                                        onChange={this.props.onChangeModel}
                                        labelError={this.props.modelSelectedField.error}
                                        hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                        disabled={disabledEditVehicle}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={'version'}
                                        label={CALCULATOR.VERSION}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.versionSelectedField.value}
                                        data={this.props.versions}
                                        required={true}
                                        onChange={this.props.onChangeVersion}
                                        labelError={this.props.versionSelectedField.error}
                                        hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                        disabled={disabledEditVehicle}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <SelectSearchComponent
                                        id={INPUTS.ASSEMBLY_COUNTRY}
                                        label={LOAN_APPLICATION_MX.ASSEMBLY_COUNTRY}
                                        placeholder={GLOBAL.SELECT}
                                        value={this.props.assemblyCountryField.value}
                                        data={this.props.assemblyCountryCatalog}
                                        required={true}
                                        onChange={this.props.onChangeAssemblyCountry}
                                        labelError={this.props.assemblyCountryField.error}
                                        helpAction={this.props.onPressHelpAssemblyCountryModal}
                                        hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}/>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-4">
                                    <InputText
                                        label={LOAN_APPLICATION_MX.EMPLOYMENT_POSTAL_CODE}
                                        id={INPUTS.EMPLOYMENT_POSTAL_CODE}
                                        value={this.props.postalCodeField.value}
                                        required={true}
                                        type={InputTextTypes.NUMBER}
                                        acceptLeadingZeros={true}
                                        maxLength={5}
                                        minLength={5}
                                        hasError={this.state.showErrors || !!!this.props.postalCodeIsValid}
                                        labelError={this.props.postalCodeField.error}
                                        placeholder={GLOBAL.ENTER_POSTAL_CODE}
                                        onChange={this.onChangePostalCode}/>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <Options id={'insurances'}
                                             name={'insurances'}
                                             options={this.props.insuranceIncludesOptions}
                                             onChange={this.props.onChangeIncludeInsurance}
                                             listGroupClass="list-group-borderless"
                                             customClassLabel="text-initial"
                                             defaultValue={this.props.hasInsurance}/>
                                    {this.props.failInsurance &&
                                        <strong
                                            className="form-text is-invalid">{ERROR.NO_BITUAJ_RESULT_WARNING}</strong>
                                    }
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col">
                                    {this.props.quotasDescription}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-12 side-calculator">
                            <div className="row">
                                <div className="col">
                                    <div className="row">
                                        <div className="col">
                                            {this.renderQuotas()}
                                        </div>
                                    </div>
                                    <div className="row mt-2 mb-3">
                                        <div className="col d-flex align-items-center justify-content-center">
                                            {this.renderNextUpdateButton()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {landing &&
                <React.Fragment>
                    <div className="container px-0">
                        <div className="row pt-5 mt-5 pt-5 pb-5">
                            <div className="col d-flex align-items-center">
                                <div className="row">
                                    <div className="col offset-md-2">
                                        <h3>Encuentra tu auto <strong>a crédito</strong></h3>
                                        <span className="rectangle mt-4 mb-4"/>
                                        <p className="description-info">
                                            Tenemos miles de opciones de autos con financiamiento. Solicita tu
                                            crédito
                                            con
                                            pre aprobación inmediata.
                                        </p>
                                        <p className="mt-5">
                                            <Link href={urlToSeminuevos}
                                                  target="_blank"
                                                  customClass="
                                                        btn btn-block d-flex align-items-center justify-content-center
                                                        "
                                                  text="Ver autos con financiamiento"/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="
                                col-md-6 col-sm-12 d-flex align-items-center justify-content-center mt-5 mt-md-0 mt-lg-0
                                ">
                                <img src={
                                    AssetsManager('/assets/images/common/landing-laptop.png')
                                } className="img-fluid" alt="car"/>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-5 mt-5 pb-5 bg-white">
                        <div className="col">
                            <div className="container">
                                <div className="row mt-5 pb-5">
                                    <div className="col-md-6 col-sm-12">
                                        <img src={
                                            AssetsManager('/assets/images/common/landing-car.png')
                                        } className="img-fluid" alt="car"/>
                                    </div>
                                    <div className="col d-flex align-items-center">
                                        <div className="row">
                                            <div className="col offset-md-2">
                                                <h3>
                                                    Bienvenido al futuro del financiamiento en línea
                                                </h3>
                                                <span className="rectangle mt-4 mb-4"/>
                                                <p className="description-info">
                                                    Motorfy es un servicio 100% online y seguro de inicio a fin
                                                    que te
                                                    permite comprar y buscar un auto a crédito.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5 pb-5">
                                    <div className="col">
                                        <h3 className="text-center">Nuestro producto incluye:</h3>
                                        <span className="rectangle ml-auto mr-auto mt-4 mb-4"/>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12">
                                                <div className="row">
                                                    <div className="col-lg-8 col-10 m-auto">
                                                        <LandingCheck
                                                            text="Acompañamiento en el proceso de inicio a fin"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-8 col-10 m-auto">
                                                        <LandingCheck text="Seguro vehicular"/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-8 col-10 m-auto">
                                                        <LandingCheck
                                                            text="
                                                Distintas opciones de crédito automotriz según el perfil del cliente"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="row">
                                                    <div className="col-lg-8 col-10 m-auto">
                                                        <LandingCheck
                                                            text="Garantía mecánica en un auto seminuevo"/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-8 col-10 m-auto">
                                                        <LandingCheck
                                                            text="Variedad de opciones de autos para elegir"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-5 pb-5">
                                    <div className="col-11 m-auto">
                                        <div className="row">
                                            <div className="col-md-4 col-sm-12">
                                                <LandingFeature icon="/assets/images/common/landing-clock.svg"
                                                                title="Rapidez"
                                                                text="
                                                        Te tomará 10 minutos llenar tu solicitud de crédito vehicular."
                                                />
                                            </div>
                                            <div className="col-md-4 col-sm-12">
                                                <LandingFeature icon="/assets/images/common/landing-write.svg"
                                                                title="Agilidad "
                                                                text="Pre aprobamos tu crédito inmediatamente"/>
                                            </div>
                                            <div className="col-md-4 col-sm-12">
                                                <LandingFeature icon="/assets/images/common/landing-hands.svg"
                                                                title="Confianza"
                                                                text="
                                                Garantizamos la seguridad de tus datos, evitando fraudes o estafas"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-5 pb-5 bg-primary">
                        <div className="col">
                            <div className="container">
                                <div className="row mt-4">
                                    <div className="col-lg-5 col-md-8 col-xs-12 m-auto text-center">
                                        <h3 className="text-white">Características de nuestras opciones de
                                            crédito</h3>
                                        <span className="rectangle ml-auto mr-auto mt-4 mb-4 bg-white"/>
                                    </div>
                                </div>
                                <div className="row mb-4 landing-features-option">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-down-payment.svg"
                                                    title="Desde <strong>20% de enganche</strong>"
                                                    option={false}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-calendar.svg"
                                                    title="Hasta <strong>48 meses</strong> de plazo"
                                                    option={false}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-slice.svg"
                                                    title="Tasas desde <strong>1.27%</strong>"
                                                    option={false}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-car.svg"
                                                    title="Vehículos hasta <strong>11 años</strong>"
                                                    option={false}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-credit-card.svg"
                                                    title="<strong>Flexibilidad en buró</strong>"
                                                    option={false}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-icon-clock.svg"
                                                    title="<strong>Pre aprobación</strong> inmediata"
                                                    option={false}/>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-8 col-10 m-auto">
                                                <LandingFeature
                                                    icon="/assets/images/common/landing-icon-hands.svg"
                                                    title="<strong>Aprobación</strong> en menos de 48 horas"
                                                    option={false}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-5 pb-5 bg-white">
                        <div className="col">
                            <div className="container">
                                <h3 className="text-center">Preguntas frecuentes:</h3>
                                <span className="rectangle ml-auto mr-auto mt-4 mb-4"/>
                                <div className="row">
                                    <SimulatorAccordion/>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export default SimulatorStepView;
